import { api } from "../../services/api";

export async function getExternalFinishings() {

    const response = await api.get('external-finishings.php');

    return response;
};

export async function getCategories() {

    const response = await api.get('categories.php');

    return response;
};

export async function getPlatings() {

    const response = await api.get('platings.php');

    return response;
};

export async function getComforts() {

    const response = await api.get('comforts.php');

    return response;
};

export async function getFormats() {

    const response = await api.get('formats.php');

    return response;
};